import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_2 = { class: "itemcard downloadcard" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Web scraping", -1)
const _hoisted_5 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_6 = { class: "itemcard downloadcard" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", null, "Market research", -1)
const _hoisted_9 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_10 = { class: "itemcard downloadcard" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "SEO monitoring", -1)
const _hoisted_13 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_14 = { class: "itemcard downloadcard" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h2", null, "Ecommerce", -1)
const _hoisted_17 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_18 = { class: "itemcard downloadcard" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h2", null, "Website testing", -1)
const _hoisted_21 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_22 = { class: "itemcard downloadcard" }
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", null, "Cybersecurity", -1)
const _hoisted_25 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_26 = { class: "itemcard downloadcard" }
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h2", null, "Ad verification", -1)
const _hoisted_29 = { class: "col-xl-3 col-lg-4 col-md-6 col-12" }
const _hoisted_30 = { class: "itemcard downloadcard" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h2", null, "Brand protection", -1)


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const img = {
  webScraping: require('@/assets/img/svg/web-scraping.svg'),
  marketResearch: require('@/assets/img/svg/market-research.svg'),
  seoMonitoring: require('@/assets/img/svg/seo-monitoring.svg'),
  eCommerce: require('@/assets/img/svg/e-commerce.svg'),
  webTesting: require('@/assets/img/svg/website-testing.svg'),
  cybersecurity: require('@/assets/img/svg/cybersecurity.svg'),
  adVerification: require('@/assets/img/svg/ad-verification.svg'),
  brandProtection: require('@/assets/img/svg/brand-protection.svg'),
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          alt: "",
          src: img.webScraping
        }, null, 8, _hoisted_3),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          alt: "",
          src: img.marketResearch
        }, null, 8, _hoisted_7),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("img", {
          src: img.seoMonitoring,
          alt: ""
        }, null, 8, _hoisted_11),
        _hoisted_12
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("img", {
          src: img.eCommerce
        }, null, 8, _hoisted_15),
        _hoisted_16
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("img", {
          src: img.webTesting
        }, null, 8, _hoisted_19),
        _hoisted_20
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("img", {
          src: img.cybersecurity
        }, null, 8, _hoisted_23),
        _hoisted_24
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("img", {
          src: img.adVerification
        }, null, 8, _hoisted_27),
        _hoisted_28
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("img", {
          src: img.brandProtection
        }, null, 8, _hoisted_31),
        _hoisted_32
      ])
    ])
  ], 64))
}
}

})